import { useFormikContext } from 'formik';

import {
  getVariableFormDataToDuplicate,
  SurveyVariableFormData,
} from '../../util/surveyVariables';
import { useModal } from '../../hooks/modals';
import Button from '../common/forms/Button';
import Icon from 'components/common/Icon';
import IconBackground from '../common/icons/IconBackground';
import Modal, { ModalHeader } from '../common/Modal';

const DuplicateVariable = ({
  onDuplicate,
}: {
  onDuplicate(formData: SurveyVariableFormData): void;
}): JSX.Element => {
  const { values } = useFormikContext<SurveyVariableFormData>();

  const {
    isOpen: isConfirmDuplicate,
    onCloseModal,
    setIsOpen: setIsConfirmDuplicate,
  } = useModal();

  return (
    <>
      <IconBackground
        onClick={() => {
          setIsConfirmDuplicate(true);
        }}
        title="Duplicate"
      >
        <div className="w-3 h-3">
          <Icon id="copy-02" />
        </div>
      </IconBackground>
      {isConfirmDuplicate && (
        <DuplicateVariableModal
          onCloseModal={onCloseModal}
          onConfirmDuplicate={() => {
            onDuplicate(getVariableFormDataToDuplicate({ formData: values }));
            onCloseModal();
          }}
        />
      )}
    </>
  );
};

export default DuplicateVariable;

const DuplicateVariableModal = ({
  onCloseModal,
  onConfirmDuplicate,
}: {
  onCloseModal(): void;
  onConfirmDuplicate(): void;
}): JSX.Element => {
  return (
    <Modal
      header={
        <ModalHeader onClickClose={onCloseModal}>
          Duplicate Variable
        </ModalHeader>
      }
      onCloseModal={onCloseModal}
      position="top"
    >
      <p>Are you sure you want to duplicate this variable?</p>
      <p>
        If you choose to duplicate, do not forget to save your new variable!
      </p>
      <div className="mt-8 flex gap-3 flex-row-reverse">
        <Button
          grow
          hierarchy="primary"
          onClick={onConfirmDuplicate}
          size="lg"
          type="button"
        >
          Duplicate
        </Button>
        <Button
          grow
          hierarchy="secondary-gray"
          onClick={onCloseModal}
          size="lg"
          type="button"
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
